<template>
   <!-- 全局提示框 -->
   <div class="toast-pay_wrapper" v-show="show" @click="close" >
       <div v-show="show" class="dialog-tips dialog-center">
            <div class="msg">{{msg}}</div>
            <div class="pay-complete" @click="completefn">已完成支付</div>
            <div class="pay-error" @click="gopay">支付遇到问题，重新支付</div>
            
        </div>
   </div>
</template>
<script>
export default {
    props:{
        show:{
            default:false
        },
        msg:{
            default:""
        }
    },
    data() {
        return {
            // msg: ""
        };
    },
    methods:{
       completefn(){
           this.$emit("payComplete");
       },
       gopay(){
           this.$emit("gopay");
       },
       close(){
           this.$emit("closeDialog");
       }
    }
    };
</script>
<style lang="scss">

</style>




// WEBPACK FOOTER //
// src/components/PayToast.vue